import { get, post, put, patch, del } from "./rest";
import store from "@/store";

const server = process.env.VUE_APP_API ?? "";

const headers = () => {
  const language =
    localStorage.getItem("locale") || process.env.VUE_APP_LANGUAGE;
  const user = store.getters.user;

  if (!user) {
    return {
      "Content-Type": "application/json",
      language: language,
    };
  }

  return {
    "Content-Type": "application/json",
    language: language,
    id: user?.member_id,
    token: user?.token,
  };
};

class clientAxios {
  async get(url: string, isParams = true) {
    return await get(`${server}/${url}`, isParams ? headers() : {});
  }

  async post(url: string, payload: any) {
    return await post(`${server}/${url}`, payload, headers());
  }

  async put(url: string, payload: any) {
    return await put(`${server}/${url}`, payload, headers());
  }

  async patch(url: string, payload: any) {
    return await patch(`${server}/${url}`, payload, headers());
  }

  async del(url: string, isParams = true) {
    return await del(`${server}/${url}`, isParams ? headers() : {});
  }
}

export default new clientAxios();
